/**
 * サンプルクラス
 * @constructor
 */
class TopParallax {

  constructor() {
    this.init();
  }

  /**
  * 初期化メソッド
  * ページ内に指定された要素（.js-topParallax）が存在する場合、トップパララックスを実行する
  */
  init() {
    if (document.querySelector('.js-topParallax')) {
      this.topParallax();
    }
  }
  topParallax() {
    const layers = document.querySelectorAll('.js-topParallax__layer');

    window.addEventListener('scroll', () => {
      layers.forEach(layer => {
        const speed = -0.3; // 移動速度の設定
        const yPos = window.scrollY * speed; // スクロール量に応じた位置計算
        layer.style.backgroundPositionY = `${yPos}px`; // 背景画像の位置を更新
      });
    });
  }
}

export default TopParallax;
